import React from "react";
import { Progress } from "antd";
import styles from "./index.module.scss";

interface StudyProgressProps {
    percent: number;
}

export default function StudyProgress({ percent }: StudyProgressProps) {
    return (
        <div className={styles.root}>
            <span className={styles.label}>学习进度</span>
            <Progress percent={percent} />
        </div>
    );
}
